import { ElectricityReceipt } from '@/components/receipts/ElectricityReceipt';
import { ExamReceipt } from '@/components/receipts/ExamReceipt';
import { Button } from '@/components/ui/Button';
import { Modal } from '@/components/ui/Modal';
import type { BillReceiptData } from '@/types/receipt';

interface BillPurchaseSuccessModalProps {
  open: boolean;
  onClose: () => void;
  receipt: BillReceiptData;
}

export function BillPurchaseSuccessModal({ open, onClose, receipt }: BillPurchaseSuccessModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      size="lg"
      title="Payment receipt"
      description="Save this receipt for your records."
      bodyClassName="px-3 py-3 sm:px-4"
      footer={
        <Button fullWidth onClick={onClose}>
          Done
        </Button>
      }
    >
      {receipt.type === 'electricity' ? (
        <ElectricityReceipt receipt={receipt} />
      ) : (
        <ExamReceipt receipt={receipt} />
      )}
    </Modal>
  );
}
